import { API, Auth } from 'aws-amplify';
import { USER_INFO_LOADED } from '../constants/actionTypes';

export function initUserInfo() {
  return async dispatch => {
    try {
      const init = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      };
      const userInfo = await API.get('UserInfoGateway', '/user_info', init);
      dispatch({ type: USER_INFO_LOADED, payload: userInfo });
    } catch (err) {
      console.warn('Could not load user info, defaulting to free tier:', err);
      dispatch({ type: USER_INFO_LOADED, payload: { tier: 'free' } });
    }
  };
}
